import { PostBase } from '@core/content';
import { mc, StyleProps } from '@styles';
import { format } from 'date-fns';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import React, { FC } from 'react';

interface Props extends StyleProps {
  post: PostBase;
  dateFormat?: string;
}

export const PostVerticalCard: FC<Props> = ({ className, post, dateFormat = 'MMMM dd, yyyy' }) => {
  const { title, categories, createdAt, authorName, description } = post;
  const image = getImage(post.headerImage as ImageDataLike);
  return (
    <a className={mc('block', className)} href={post.url}>
      {/* Image */}
      {image && <GatsbyImage className={mc('w-full h-[300px]', 'rounded-xl overflow-hidden')} alt={title} image={image} />}
      {/* Image Ends */}
      {/* Tags */}
      <div className={mc('mt-6', 'flex flex-row flex-wrap')}>
        {categories.map(itm => (
          <div
            key={itm}
            className={mc(
              'px-4 py-0.5 mr-1.5 mb-1.5',
              'bg-seafoam/50',
              'rounded-full',
              'text-sm font-opensans leading-normal text-center font-semibold text-ocean-blue',
            )}
          >
            {itm}
          </div>
        ))}
      </div>
      {/* Tags End */}
      {/* Title */}
      <h3 className={mc('m-0 p-0 mt-2.5', 'text-xl font-raleway leading-normal font-bold text-ocean-blue')}>{title}</h3>
      {/* Title End */}
      {/* Description */}
      {!!description && (
        <div className={mc('mt-2', 'text-base font-raleway leading-normal font-medium text-ocean-blue')}>{description}</div>
      )}
      {/* Description End */}
      {/* Author */}
      {!!authorName && (
        <div className={mc('mt-4', 'text-xs font-raleway leading-normal font-semibold text-ocean-blue')}>
          {'Written by '}
          <span className={mc('underline hover:underline font-bold')}>{authorName}</span>
        </div>
      )}
      {/* Author End */}
      {/* Info */}
      <div
        className={mc(
          'mt-4',
          'flex flex-row items-center justify-start',
          'text-xs font-raleway leading-normal font-medium text-ocean-blue',
        )}
      >
        <div className={mc('pr-2.5')}>{format(new Date(createdAt), dateFormat)}</div>
      </div>
      {/* Info End */}
    </a>
  );
};

export type PostVerticalCardProps = Props;
export default PostVerticalCard;
